import { render, staticRenderFns } from "./CartDropdownComponent.vue?vue&type=template&id=05b5e5f2"
import script from "./CartDropdownComponent.vue?vue&type=script&lang=js"
export * from "./CartDropdownComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports